"use client";
export { Icon as default } from "../../../_Builtin/Basic";
